"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizePinIdForComparison = normalizePinIdForComparison;
function normalizePinIdForComparison(raw) {
    const trimmed = raw.trim();
    const match = /^0*(\d+)(?:\.0+)?$/.exec(trimmed);
    return match?.[1] ?? trimmed;
}
//# sourceMappingURL=pin-id-normalization.js.map